import {useEditorMaybe} from '@grapesjs/react';
import React, {useEffect, useState} from 'react';
import {portalContainer} from './utils';
import {getAppEditorStore} from "../../../app/store/appEditorStore";
import {getUndoManager, RTEActionStack} from "../../../app/store/UndoManager";

export default function CustomRTE({children}) {
    const editor = useEditorMaybe();
    const [propState, setPropState] = useState({
        enabled: false,
        actions: [],
        Container: () => null,
    });

    useEffect(() => {
        if (!editor) return;
        const rte = editor.RichTextEditor;
        const event = rte.events.custom;

        const toListen = (props) => {
            const actions = rte.getAll().map(action => ({
                id: action.name,
                icon: action.icon,
                run: (event) => {
                    const selected = editor.getSelected();
                    const selectedHtml = selected.toHTML();
                    const innerHtml = selected.view.el.innerHTML;
                    rte.run(action);
                    if (innerHtml !== selected.view.el.innerHTML) {
                        const selectorInfo = getAppEditorStore().getComponentSelector(selected);
                        getUndoManager().add(new RTEActionStack(Object.assign(selectorInfo, {html: selectedHtml})));
                        editor.select(null);
                    }

                },
                state: action.currentState,
            }));
            setPropState({
                enabled: props.enabled,
                Container: portalContainer(props.container),
                actions,
            });
        }

        editor.on(event, toListen);

        return () => {
            editor.off(event, toListen)
        };
    }, [editor]);

    const {Container} = propState;

    return editor && Container ?
        <Container>
            {children(propState)}
        </Container>
        : null;
}

/**
 * I just need to pass RTE actions to the CustomRTE
 * Hide it when it's enabled
 * Can I decide when to keep it enabled so I can place RTE whenever I want
 * I should also access to the active component/componentView
 */